import { StandardFormMetaInfo } from '../../../../common/modules/inspark-page-standard-forms/standard-form-builder/standard-form-meta-info.model';
import { StandardFormTypes } from '../../../../common/modules/inspark-page-standard-forms/standard-form-builder/standard-form-types.enum';

export const RuleoverviewStandardFormMeta: StandardFormMetaInfo[] = [
  {field: 'rulename', label: 'Rulename', type: StandardFormTypes.varchars, required: true, columnWidth: '10%', constraints: {maxLength: 100}},
  {field: 'comment', label: 'Comment', type: StandardFormTypes.varchars, required: false, columnWidth: '10%', constraints: {maxLength: 254}},
  {
    field: 'location',
    item: {key: 'name', options: 'locations'},
    label: 'Location',
    type: StandardFormTypes.radiogroup,
    required: true,
    columnWidth: '10%',
    value: (data) => data.location.name
  },
  {field: 'delaytime', label: 'Delaytime', type: StandardFormTypes.int, required: false, columnWidth: '10%'},
  {
    field: 'typicalconfig',
    item: {key: 'configname', options: 'typicalconfigs'},
    label: 'TypicalConfig',
    type: StandardFormTypes.item,
    disabled: true,
    required: true,
    columnWidth: '10%',
    value: (data) => data.typicalconfig.configname
  },
  {field: 'message', label: 'Event', type: StandardFormTypes.varchars, required: false, columnWidth: '10%', constraints: {maxLength: 254}},
  {field: 'id', label: 'Id', type: StandardFormTypes.int, columnWidth: '80px', isHidden: true, disabled: true, invisible: true}
];
